import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/lib/supabase";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    // Check if this is an OAuth callback with tokens in the hash
    // This handles the case where Supabase redirects to root instead of /auth/callback
    if (typeof window !== "undefined" && (window.location.hash.includes("access_token") || new URLSearchParams(window.location.search).has("code"))) {
      // Let Supabase process the tokens from the hash
      // detectSessionInUrl is enabled, so getSession() will parse the hash
      await supabase.auth.getSession();
      // After processing, redirect to clubs (session is now stored)
      throw redirect({ to: "/clubs" });
    }

    // Redirect to clubs as the default landing page
    throw redirect({ to: "/clubs" });
  },
});
